import { useEntity } from '@backstage/plugin-catalog-react';
import { PdsAlert, PdsLink } from '@principal/design-system-react';

import { WellArchitected } from './types';

export function AccountSealedCard() {
  const { entity } = useEntity();
  const wa_obj = entity.metadata?.['well-architected'] as WellArchitected;
  const status_text = wa_obj?.status;
  let sealed = false;
  if (status_text === 'unapproved') {
    sealed = true;
  }

  const documentation_url =
    '/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/architecture/aws-production-account-gate/';

  return (
    <>
      {sealed && (
        <>
          <div
            style={{
              color: '#222222',
            }}
          >
            <PdsAlert variant="error">
              Most actions are restricted in this workload account. Complete a
              well-architected review to activate this account. Review the{' '}
              <PdsLink variant="strong" href={documentation_url}>
                AWS Production Account Gate
              </PdsLink>{' '}
              documentation for more information.
            </PdsAlert>
          </div>
          <br />
        </>
      )}
    </>
  );
}
